import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsOptional, IsString } from "class-validator";

import { ClientInfo } from "../types/ClientInfo";

@Exclude()
export class RequestHeader {
  @IsString()
  @IsDefined()
  @Expose()
  public remoteAddress: string;

  @IsString()
  @IsDefined()
  @Expose()
  public userAgent: string;

  @IsString()
  @Expose()
  public cid?: string;

  @Expose()
  @IsOptional()
  public client?: ClientInfo;
}
